import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';
import { TemplateContainer } from './utils';
import TemplateDialog from './dialog';
import api from '../../infrastructure/api/api';
import { emptyGuid } from '../../utils/constants';

export const TemplateEditor = props => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const [templateDialogOpen, setTemplateDialogOpen] = useState(false);
  const [newPositionTemplate, setNewPositionTemplate] = useState({
    rules: [],
    name: '',
  });
  const [positionTemplate, setPositionTemplate] = useState({
    rules: [],
    name: '',
  });
  const [selectOptions, setSelectOptions] = useState({});
  const [eventTypes, setEventTypes] = useState([]);
  const [fieldsAndTemplates, setFieldsAndTemplates] = useState({
    customFields: [],
    accountingObjects: [],
  });
  const [positionCount, setPositionCount] = useState(0);

  useEffect(() => {
    if (props.positionType) {
      api
        .get(
          `eventTypeConfiguration?positionType=${props.positionType}`,
          enqueueSnackbar,
          t
        )
        .then(eventTypesResult => {
          if (eventTypesResult) {
            setEventTypes(eventTypesResult);
          }
        });

      api
        .get('fieldsAndTemplates', enqueueSnackbar, t)
        .then(fieldsAndTemplatesResult => {
          if (fieldsAndTemplatesResult) {
            setFieldsAndTemplates(fieldsAndTemplatesResult);
          }
        });

      api
        .get('templateRuleFieldConfiguration', enqueueSnackbar, t)
        .then(selectOptionsResult => {
          if (selectOptionsResult !== null) {
            setSelectOptions(selectOptionsResult);
          }
        });

      setNewPositionTemplate({
        archived: false,
        positionTemplateId: emptyGuid,
        name: '',
        positionType: props.positionType,
        rules: [],
      });
    }
  }, [enqueueSnackbar, props.positionType, t]);

  useEffect(() => {
    if (props.dialogObject.positionTemplateId === emptyGuid) {
      setPositionTemplate({ ...newPositionTemplate });
      setPositionCount(0);
      setTemplateDialogOpen(props.dialogObject.isOpen);
    } else if (props.dialogObject.positionTemplateId) {
      api
        .get(
          `positionTemplates?id=${props.dialogObject.positionTemplateId}`,
          enqueueSnackbar,
          t
        )
        .then(positionTemplateResult => {
          if (positionTemplateResult !== null) {
            setPositionTemplate(positionTemplateResult);
            setTemplateDialogOpen(props.dialogObject.isOpen);
          }
        });
      api
        .get(
          `positionFields/CountByTemplate?positionTemplateId=${props.dialogObject.positionTemplateId}`,
          enqueueSnackbar,
          t
        )
        .then(positionCountResult => {
          setPositionCount(+positionCountResult);
        });
    } else {
      setTemplateDialogOpen(props.dialogObject.isOpen);
    }
  }, [enqueueSnackbar, newPositionTemplate, props.dialogObject, t]);

  const closeTemplateDialog = useCallback(() => {
    setTemplateDialogOpen(false);
    props.closeDialog();
  }, [props]);

  return (
    <TemplateContainer.Provider>
      <TemplateDialog
        isOpen={templateDialogOpen}
        closeDialog={closeTemplateDialog}
        templateSaved={props.dialogObject.templateSaved}
        positionTemplate={positionTemplate}
        selectOptions={selectOptions}
        eventTypes={eventTypes}
        fieldsAndTemplates={fieldsAndTemplates}
        positionCount={positionCount}
      />
    </TemplateContainer.Provider>
  );
};

TemplateEditor.propTypes = {
  closeDialog: PropTypes.func,
  positionType: PropTypes.string,
  dialogObject: PropTypes.object.isRequired,
};
